//Discount Banner
const Discount = () => {
  return (
    <div className="bg-green-200 text-green-800 p-4 mb-4 rounded">
      Hurrah! You get 10% off!
    </div>
  );
};

export default Discount;
